
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.813 17.357l-.382.527-.002-.002-.005-.003-.017-.012a6.873 6.873 0 01-.284-.204 21.954 21.954 0 01-3.136-2.857c-1.7-1.89-3.487-4.61-3.487-7.735 0-1.875.77-3.674 2.142-5A7.44 7.44 0 018.812 0c1.94 0 3.8.745 5.171 2.071a6.955 6.955 0 012.142 5c0 3.125-1.787 5.844-3.487 7.735a21.947 21.947 0 01-3.136 2.857 12.632 12.632 0 01-.284.204l-.017.012-.005.003-.001.001-.383-.526zm0 0l.38.527a.684.684 0 01-.762 0l.382-.527zm0-12.857a2.813 2.813 0 100 5.625 2.813 2.813 0 000-5.625z","fill":"currentColor"}})])
          )
        }
      }
    